const state = {
  routesBefore: []
};
const getters = {
  getRouterBefore(state) {
    return state.routesBefore[0];
  }
};
const actions = {
  setRouterBefore({ commit }, route) {
    return commit("setRouterBefore", route);
  }
};
const mutations = {
  setRouterBefore(state, route) {
    if (route && route.name) {
      state.routesBefore.unshift(route);
    } else {
      state.routesBefore.shift();
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
